import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "utc-subtitle" }, "Kết quả học tập THPT", -1)
const _hoisted_4 = { class: "col-12 sm:col-4 flex flex-column gap-2" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-wrap align-items-center justify-content-between gap-2" }, " Điểm trung bình 3 năm THPT ", -1)
const _hoisted_7 = { class: "grid" }

import { computed } from "vue";
import Divider from "primevue/divider";
import DataTable from "primevue/datatable";
import SelectButton from 'primevue/selectbutton';
import Column from "primevue/column";
import { GraduationYears } from "../categories";
import { Options } from '@/models/Options.model';
import DropdownWithLabel from "@/commons/DropdownWithLabel.vue";
import CalanderWithLabel from "@/commons/CalanderWithLabel.vue";
import InputNumberWithLabel from "@/commons/InputNumberWithLabel.vue";
import { Nullable } from "primevue/ts-helpers";
import { Field } from 'vee-validate';

export default /*#__PURE__*/_defineComponent({
  __name: 'KetQuaHocTap',
  props: {
    graduationYear: {},
    ieltsMark: {},
    ieltsDate: {},
    options: {},
    marks: {},
    academicRank: {},
    conductRank: {},
    foreignSubjectId: {}
  },
  emits: ["update:marks", "update:graduationYear", "update:ieltsMark", "update:academicRank", "update:conductRank", "update:foreignSubjectId", "update:ieltsDate"],
  setup(__props: any, { emit }) {

const props = __props;




const marksModel = computed({
  get: () => props.marks,
  set: (val) => {
    emit("update:marks", val);
  },
});

const graduationYearModel = computed({
  get: () => props.graduationYear,
  set: (val) => emit("update:graduationYear", val),
});

const ieltsMarkModel = computed({
  get: () => props.ieltsMark,
  set: (val) => emit("update:ieltsMark", val),
});
const academicRankModel = computed({
  get: () => props.academicRank,
  set: (val: any) => emit("update:academicRank", val),
});
const conductRankModel = computed({
  get: () => props.conductRank,
  set: (val: any) => emit("update:conductRank", val),
});
const ieltsDateModel = computed({
  get: () => props.ieltsDate,
  set: (val) => emit("update:ieltsDate", val),
});
const foreignSubjectIdModel = computed({
  get: () => props.foreignSubjectId,
  set: (val) => emit("update:foreignSubjectId", val),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Divider), {
        align: "center",
        type: "solid"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode(DropdownWithLabel, {
      options: _unref(GraduationYears),
      "option-label": "text",
      "option-value": "value",
      modelValue: graduationYearModel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((graduationYearModel).value = $event)),
      name: "graduationYear",
      class: "col-12 sm:col-4",
      label: "Năm tốt nghiệp",
      placeholder: "Chọn năm tốt nghiệp"
    }, null, 8, ["options", "modelValue"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(InputNumberWithLabel, {
        name: "ieltsMark",
        label: 'Điểm ielts (nếu có)',
        modelValue: ieltsMarkModel.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ieltsMarkModel).value = $event)),
        "min-fraction-digits": 0,
        "max-fraction-digits": 2
      }, null, 8, ["label", "modelValue"])
    ]),
    _createVNode(CalanderWithLabel, {
      label: "Ngày cấp chứng chỉ ielts",
      name: "ieltsDate",
      modelValue: ieltsDateModel.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ieltsDateModel).value = $event)),
      class: "col-12 sm:col-4 flex flex-column gap-2"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(DataTable), { value: marksModel.value }, {
        header: _withCtx(() => [
          _hoisted_6
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            header: "Môn học",
            field: "title",
            class: "w-2"
          }),
          _createVNode(_unref(Column), { header: "Lớp 10" }, {
            body: _withCtx(({ data, index }) => [
              _createVNode(InputNumberWithLabel, {
                name: `subjectMarks[${index}].class10`,
                label: "",
                modelValue: data.class10,
                "onUpdate:modelValue": ($event: any) => ((data.class10) = $event),
                "min-fraction-digits": 0,
                "max-fraction-digits": 2
              }, null, 8, ["name", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), { header: "Lớp 11" }, {
            body: _withCtx(({ data, index }) => [
              _createVNode(InputNumberWithLabel, {
                name: `subjectMarks[${index}].class11`,
                label: "",
                modelValue: data.class11,
                "onUpdate:modelValue": ($event: any) => ((data.class11) = $event),
                "min-fraction-digits": 0,
                "max-fraction-digits": 2
              }, null, 8, ["name", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), { header: "Lớp 12" }, {
            body: _withCtx(({ data, index }) => [
              _createVNode(InputNumberWithLabel, {
                name: `subjectMarks[${index}].class12`,
                label: "",
                modelValue: data.class12,
                "onUpdate:modelValue": ($event: any) => ((data.class12) = $event),
                "min-fraction-digits": 0,
                "max-fraction-digits": 2
              }, null, 8, ["name", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(DropdownWithLabel, {
          label: "Kết quả học tập lớp 12*",
          name: "academicRankId",
          modelValue: academicRankModel.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((academicRankModel).value = $event)),
          "option-value": "value",
          options: _ctx.options.academicRanks,
          "option-label": "text",
          class: "col-12 sm:col-6"
        }, null, 8, ["modelValue", "options"]),
        _createVNode(DropdownWithLabel, {
          label: "Kết quả rèn luyện lớp 12*",
          name: "conductRankId",
          modelValue: conductRankModel.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((conductRankModel).value = $event)),
          "option-value": "value",
          options: _ctx.options.conductRanks,
          "option-label": "text",
          class: "col-12 sm:col-6"
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}
}

})